import routerMiddlewares from "src/control/middlewares/commons/router_middleware";
import regionsMiddlewares from "src/control/middlewares/commons/regions_middleware";

export default [
    ...routerMiddlewares,
    ...regionsMiddlewares
]